import { render, staticRenderFns } from "./VitaInvestimento.vue?vue&type=template&id=2bacbe58&scoped=true&"
import script from "./VitaInvestimento.vue?vue&type=script&lang=ts&"
export * from "./VitaInvestimento.vue?vue&type=script&lang=ts&"
import style0 from "./VitaInvestimento.vue?vue&type=style&index=0&id=2bacbe58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bacbe58",
  null
  
)

export default component.exports